<template>
  <div v-if="shipmentInfo">
    <div>
      <div
        class="shipment-modal-container"
        :class="[open ? 'open' : 'closed']"
      >Successfully Created Shipment!</div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {};
  },
  props: ["open", "shipmentInfo"],
  methods: {}
};
</script>

<style scoped>
.open {
  opacity: 1;
  top: 0;
  transition: 0.3s ease-in-out;
}
.closed {
  top: -100%;
  opacity: 0;
  transition: 0.3s ease-in-out;
}
.shipment-modal-container {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
  background: white;
  margin-top: 0;
  padding: 1.5em;
  font-size: 1rem;
  background-color: #8dc641;
  color: white;
}
h1 {
  padding: 1rem;
  margin: 0;
  margin-bottom: 1rem;
  background: lightgrey;
  border-bottom: 1px solid black;
}
</style>
